import { Button } from 'components';
import { useFormikContext } from 'formik';
import { useIsOnlyVisibleToUserWithPermissions } from 'utils/hooks/useIsOnlyVisibleTo';
import { PERMISSION } from 'utils/protectedRoutes/userRolesAndPermissionTypes';

import { useAutosaveContext } from '../context/autosaveContext';
import { NoteFormValues } from '../utils/validation';
import style from '../noteEdit.module.scss';

type SubmitButtonProps = {
  children: string;
  className?: string;
  disabled?: boolean;
};

export const SubmitButton = ({ children, className, disabled = false }: SubmitButtonProps) => {
  const formik = useFormikContext<NoteFormValues>();
  const { isAutosaveBusy } = useAutosaveContext();
  const canUpdateManagerReview = useIsOnlyVisibleToUserWithPermissions([
    PERMISSION.UPDATE_MANAGER_REVIEW
  ]);

  const isDisabled =
    !formik.isValid ||
    disabled ||
    formik.isSubmitting ||
    isAutosaveBusy ||
    (!canUpdateManagerReview && formik.values.noteType === 'MANAGER_REVIEW');

  return (
    <Button
      customStyleClass={className || style.submit}
      theme="primary"
      type="submit"
      disabled={isDisabled}
      text={children}
    />
  );
};
